var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgBlockFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.11111,
    fill: "var(--red-5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27815 3.55554H8.86503L8.75765 9.74794H7.38554L7.27815 3.55554ZM7.11111 11.478C7.11111 11.2075 7.20259 10.9808 7.38554 10.7979C7.56848 10.6149 7.79518 10.5235 8.06563 10.5235C8.34402 10.5235 8.5747 10.6149 8.75765 10.7979C8.94059 10.9808 9.03207 11.2075 9.03207 11.478C9.03207 11.7564 8.94059 11.9871 8.75765 12.17C8.5747 12.353 8.34402 12.4444 8.06563 12.4444C7.79518 12.4444 7.56848 12.353 7.38554 12.17C7.20259 11.9791 7.11111 11.7484 7.11111 11.478Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockFilled);
export default __webpack_public_path__ + "static/media/blockFilled.b0553c3a8f05c342c1f90201d4b2f706.svg";
export { ForwardRef as ReactComponent };